export class IdClass {
  id: number;
  name: string;

  constructor() {
    this.id = null;
    this.name = null;
  }
}
